import React from "react";
import PropTypes from "prop-types";
import {Price} from "./Price";

export const PriceWithFallback = ({ data, config, fallback }) => {
    const sellingPrice = data?.sellingPrice;

    const hasSellingPrice =
        sellingPrice !== undefined &&
        sellingPrice !== null &&
        sellingPrice !== "";

    if (!hasSellingPrice) {
        return (
            fallback ?? (
                <span className="text-warning">
                    Precio online no disponible
                </span>
            )
        );
    }

    return <Price data={data} config={config} />;
};

PriceWithFallback.propTypes = {
    data: PropTypes.shape({
        sellingPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        basePrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    config: Price.propTypes.config,
    fallback: PropTypes.node,
};
